import { LoaderCircle } from 'lucide-react'
import { cn } from '~/lib/utils'

export const PageLoader = ({
	className,
}: {
	className?: string
}) => (
	<div className={cn('flex items-center justify-center', className)}>
		<LoaderCircle
			size={50}
			className='animate-spin text-primary'
		/>
	</div>
)
